var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDashboard = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 33,
  height: 33,
  viewBox: "0 0 33 33",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.5444 4.39482H5.87777C5.14139 4.39482 4.54443 4.99177 4.54443 5.72815V15.0615C4.54443 15.7979 5.14139 16.3948 5.87777 16.3948H12.5444C13.2808 16.3948 13.8778 15.7979 13.8778 15.0615V5.72815C13.8778 4.99177 13.2808 4.39482 12.5444 4.39482Z",
  stroke: "white",
  strokeWidth: 1.33333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.2111 4.39482H20.5444C19.8081 4.39482 19.2111 4.99177 19.2111 5.72815V9.72815C19.2111 10.4645 19.8081 11.0615 20.5444 11.0615H27.2111C27.9475 11.0615 28.5444 10.4645 28.5444 9.72815V5.72815C28.5444 4.99177 27.9475 4.39482 27.2111 4.39482Z",
  stroke: "white",
  strokeWidth: 1.33333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.2111 16.3948H20.5444C19.8081 16.3948 19.2111 16.9918 19.2111 17.7282V27.0615C19.2111 27.7979 19.8081 28.3948 20.5444 28.3948H27.2111C27.9475 28.3948 28.5444 27.7979 28.5444 27.0615V17.7282C28.5444 16.9918 27.9475 16.3948 27.2111 16.3948Z",
  stroke: "white",
  strokeWidth: 1.33333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5444 21.7282H5.87777C5.14139 21.7282 4.54443 22.3251 4.54443 23.0615V27.0615C4.54443 27.7979 5.14139 28.3948 5.87777 28.3948H12.5444C13.2808 28.3948 13.8778 27.7979 13.8778 27.0615V23.0615C13.8778 22.3251 13.2808 21.7282 12.5444 21.7282Z",
  stroke: "white",
  strokeWidth: 1.33333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDashboard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dashboard.c9225a2d.svg";
export { ForwardRef as ReactComponent };